export function CastlehaleMark({ className = "" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 64 64" role="img" aria-labelledby="castlehale-mark-title">
      <title id="castlehale-mark-title">Castlehale Press rook</title>
      <path
        className="mark-rook"
        fill="currentColor"
        fillRule="evenodd"
        d="M17 10h8v7h5v-7h4v7h5v-7h8v16H17V10Zm5 20h20l2.8 18H19.2L22 30Zm7 5.5L27.6 44h8.8L35 35.5h-6ZM18 51h28v4H18v-4Zm-4 7h36v4H14v-4Z"
        clipRule="evenodd"
      />
      <path className="mark-cut" d="M24 26h16v4H24z" />
    </svg>
  );
}
